module.exports = __webpack_public_path__ + "static/media/wheeled-BG-4th-layer-four@2x.733c1377.png";